import $ from 'jquery';
import offcanvas from 'modules/offcanvas';
import navigation from 'modules/navigation';
import pushNavigation from 'modules/push-navigation';
import jqueryEventSwipe from 'jquery.event.swipe';
import slider from 'modules/slider';
import accordion from 'modules/accordion';
import collapse from 'modules/collapse';
import platform from 'modules/platform';

import map from 'modules/map';
import search from 'modules/search';
import blog from 'modules/blog';

import hacky from 'modules/hacky-fixes';
import pommfritt from 'modules/tifigs-pommfritt';

//import inputs from 'modules/inputs';



$(() => {
	platform();
  offcanvas();
  navigation();
  pushNavigation();
  slider();
  accordion();
  collapse();
  pommfritt();
  //search();
  //inputs();
});



// WEBPACK FOOTER //
// ./BBZP/Frontend/js/app.js